import { Component, ComponentRef, Inject, TemplateRef, ViewChild, ViewContainerRef, Type } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LazyLoaderService } from '@core/lazy';

export interface FullScreenDialogParams {
    height?: string;
    width?: string;
    component?: Type<unknown>;
    inputs?: Record<string, unknown>;
    hideCloseButton?: boolean;
}

@Component({
    selector: 'app-full-screen-dialog',
    templateUrl: './full-screen-dialog.component.html',
    styleUrls: ['./full-screen-dialog.component.scss'],
    standalone: false
})
export class FullScreenDialogComponent {
    @ViewChild('target', { read: ViewContainerRef, static: false })
    private viewContainerRef!: ViewContainerRef;

    @ViewChild('loader', { read: TemplateRef, static: true })
    private loaderTemplateRef!: TemplateRef<unknown>;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public componentRef!: ComponentRef<any>;

    public hideCloseButton = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: FullScreenDialogParams,
        public dialogRef: MatDialogRef<FullScreenDialogComponent>,
        private readonly lazyLoader: LazyLoaderService
    ) {
    }

    public ngAfterViewInit(): void {
        this.viewContainerRef.createEmbeddedView(this.loaderTemplateRef);

        if (this.data.component) {
            this.viewContainerRef.clear();
            this.componentRef = this.viewContainerRef.createComponent(this.data.component);
            this.hideCloseButton = this.data.hideCloseButton ?? false;

            if (this.data.inputs) {
                Object.entries(this.data.inputs).forEach(([key, value]) => {
                    this.componentRef.setInput(key, value);
                });
            }
        } else {
            throw new Error('You HAVE TO provide module or component param');
        }

        this.componentRef.changeDetectorRef.detectChanges();
    }
}
